// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    width: 100%;
    background-color: #007bff;
    color: white;
    padding: 10px 0;
    margin-top: 20px;
  }
  
  .footer p {
    margin: 0;
    font-size: 1em;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB","sourcesContent":[".footer {\n    width: 100%;\n    background-color: #007bff;\n    color: white;\n    padding: 10px 0;\n    margin-top: 20px;\n  }\n  \n  .footer p {\n    margin: 0;\n    font-size: 1em;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
